import sortBySortOrder from '../../utils/sortBySortOrder';

export default function SharedApi({ makeRequest, buildRequest }) {

    // Regions
    function getRegions() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get('/api/Shared/Regions')).then(sortBySortOrder);
        });
    }

    function upsertRegion(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/Shared/Regions/Upsert', payload));
        });
    }

    function deleteRegion(regionId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`/api/Shared/Regions/${regionId}`));
        });
    }

    // Areas
    function getAreasByRegion(regionId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`/api/Shared/Areas/${regionId}`)).then(sortBySortOrder);
        });
    }

    function upsertArea(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/Shared/Areas/Upsert', payload));
        });
    }

    function deleteArea(areaId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`/api/Shared/Areas/${areaId}`));
        });
    }

    // Addresses
    function getAddresses() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get('/api/Shared/Addresses'));
        });
    }

    function upsertAddress(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/Shared/Addresses/Upsert', payload));
        });
    }

    function deleteAddress(addressId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`/api/Shared/Addresses/${addressId}`));
        });
    }

    // Roles
    function getRoles() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get('/api/Shared/Roles'));
        });
    }

    function upsertRole(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/Shared/Roles/Upsert', payload));
        });
    }

    function deleteRole(roleId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`/api/Shared/Roles/${roleId}`));
        });
    }

    // Tags
    function getTags(categoryTypeCode) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get('/api/Shared/Tags', {
                params: categoryTypeCode ? { CategoryTypeCode: categoryTypeCode } : undefined,
            }));
        });
    }

    function upsertTag(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/Shared/Tags/Upsert', payload));
        });
    }

    function deleteTag(tagId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`/api/Shared/Tags/${tagId}`));
        });
    }

    // Document Types
    function getDocumentTypes(categoryTypeCode) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get('/api/Shared/DocumentTypes', {
                params: categoryTypeCode ? { categoryTypeCode } : undefined,
            }));
        });
    }

    function upsertDocumentType(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/Shared/DocumentTypes/Upsert', payload));
        });
    }

    function deleteDocumentType(documentTypeId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`/api/Shared/DocumentTypes/${documentTypeId}`));
        });
    }

    // Category Types (read-only lookup used for hierarchy selection)
    function getCategoryTypes() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get('/api/Shared/CategoryTypes'));
        });
    }

    return {
        getRegions,
        upsertRegion,
        deleteRegion,
        getAreasByRegion,
        upsertArea,
        deleteArea,
        getAddresses,
        upsertAddress,
        deleteAddress,
        getRoles,
        upsertRole,
        deleteRole,
        getTags,
        upsertTag,
        deleteTag,
        getDocumentTypes,
        upsertDocumentType,
        deleteDocumentType,
        getCategoryTypes,
    };
}
